import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { NewbuildingBrokerSidebarBanner } from 'shared/components/NewbuildingBrokerSidebarBanner';
import { selectIsUnmatchedContentExperiment } from 'shared/selectors/abExperiments';
import { selectDIYEnabled } from 'shared/selectors/newbuildingBrokerDIY';
import { trackDIYEntryPointClick, trackDIYEntryPointShow } from 'shared/utils/newbuildingBroker/DIY';

const SOURCE = 'card_independent_banner_at_sidebar';

export const NewbuildingBrokerSidebarBannerContainer: React.FC = () => {
  const isDIYEnabled = useSelector(selectDIYEnabled);
  const isUnmatchedContentExperiment = useSelector(selectIsUnmatchedContentExperiment);

  const handleShow = React.useCallback(() => {
    trackDIYEntryPointShow(SOURCE);
  }, []);

  const handleClick = React.useCallback(() => {
    trackDIYEntryPointClick(SOURCE);
    // TODO: Реализовать открытие DIY в CD-262356.
  }, []);

  if (!isDIYEnabled || !isUnmatchedContentExperiment) {
    return null;
  }

  return (
    <ActionAfterViewObserver callback={handleShow}>
      <NewbuildingBrokerSidebarBanner loading={false} onClick={handleClick} />
    </ActionAfterViewObserver>
  );
};
